var map = {
	"./bonus-title.png": 2918,
	"./carousel1-bg.png": 1645,
	"./carousel1.png": 6190,
	"./carousel2-bg.png": 8955,
	"./carousel2.png": 6147,
	"./company-qrcode.png": 1728,
	"./customer-qrcode.png": 4890,
	"./customer-service.png": 6117,
	"./data-database.png": 1415,
	"./data-exam.png": 4258,
	"./data-math.png": 8349,
	"./data-programming.png": 6532,
	"./data-pyquantGame.png": 1470,
	"./data-system.png": 4122,
	"./header-icon-paisen.png": 8470,
	"./header-icon.png": 4464,
	"./header-name-icon-paisen.png": 896,
	"./header-name-icon.png": 393,
	"./menu-job-active.png": 4828,
	"./menu-job.png": 264,
	"./menu-python-active.png": 6451,
	"./menu-python.png": 1539,
	"./menu-quantify-active.png": 5496,
	"./menu-quantify.png": 2725,
	"./menu-software-active.png": 2337,
	"./menu-software.png": 9370,
	"./menu-strategy-active.png": 7459,
	"./menu-strategy.png": 5287,
	"./menu-system-active.png": 3087,
	"./menu-system.png": 5799,
	"./page-header-icon.png": 1855,
	"./service-qrcode.png": 7882,
	"./slogan-img.png": 328,
	"./strategy-ai.png": 5930,
	"./strategy-cb.png": 5356,
	"./strategy-etf.png": 983,
	"./strategy-fof.png": 1442,
	"./strategy-frequency.png": 4729,
	"./strategy-futures.png": 9754,
	"./strategy-options.png": 8467,
	"./strategy-stock.png": 5274,
	"./strategy.png": 8229,
	"./vip-ai-active.png": 2329,
	"./vip-ai.png": 7903,
	"./vip-arrow.png": 9968,
	"./vip-cb-active.png": 3943,
	"./vip-cb.png": 4742,
	"./vip-etf-active.png": 6151,
	"./vip-etf.png": 5118,
	"./vip-fof-active.png": 3004,
	"./vip-fof.png": 1694,
	"./vip-frequency-active.png": 3771,
	"./vip-frequency.png": 5265,
	"./vip-futures-active.png": 1012,
	"./vip-futures.png": 5263,
	"./vip-left.png": 562,
	"./vip-options-active.png": 8295,
	"./vip-options.png": 2502,
	"./vip-right.png": 2978,
	"./vip-stock-active.png": 6779,
	"./vip-stock.png": 240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4457;